/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ a: NonNullable<unknown> }} Send_DetailsInputs */



/**
* | output |
* | --- |
* | "Send details to {a}" |
*
* @param {Send_DetailsInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const send_details = /** @type {((inputs: Send_DetailsInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Send_DetailsInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ (`Send details to ${i?.a}`)
	return /** @type {LocalizedString} */ (`Envoyer les détails à ${i?.a}`)
});